export var COMMON_PALETTE = {
  primary: {
    light: "#3e7aff",
    main: "#0050FF",
    dark: "#0A2267",
    contrastText: "#fff"
  },
  secondary: {
    light: "rgba(0, 167, 147, 0.4)",
    main: "#00A793",
    dark: "#017B6D",
    contrastText: "#fff"
  },
  contrast: {
    light: "#eaecf0",
    main: "#F0F1F4",
    text: "#0A2267",
    contrastText: "#0A2267"
  },
  text: {
    primary: "#0A2267",
    secondary: "#798193" //grey

  },
  error: {
    light: "#e57373",
    main: "#f44336",
    dark: "#d32f2f",
    contrastText: "#fff"
  },
  success: {
    main: "#4caf50",
    contrastText: "#fff"
  },
  dialogues: {
    customer: {
      background: "#EAECF0",
      text: "#0A2267",
      borderRadius: 10
    },
    expert: {
      background: "#D3E1FF",
      text: "#0A2267",
      borderRadius: 10
    },
    expiry: {
      background: "#616161",
      text: "#fafafa",
      borderRadius: 10
    },
    system: {
      background: "#616161",
      text: "#fafafa",
      borderRadius: 4
    }
  },
  star: {
    fill: "#FFB300",
    border: "#D7D7D7"
  },
  smiley: {
    fill: "#f5f5f5",
    border: "1px solid rgba(163,168,168, 0.5)",
    borderRadius: 4
  }
};